<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_procedure') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.procedure') }} <strong>{{ ac.name }}</strong><br><i class="subline">{{ t('common.labels.status') }}: {{ t('common.labels.' + ac.status_with_requested_as_planned) }}</i></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

        <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
          <app-ac-new *ngIf="newMode()"></app-ac-new>
          <app-ac-basedata *ngIf="editMode()" [ac]="ac" (setEdit)="setEdit($event)"></app-ac-basedata>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.persons') }}" leftIcon="pi pi-users" [disabled]="isDisabled('persons') || ac === null">
          <app-ac-persons *ngIf="editMode()" [(ac)]="ac" (setEdit)="setEdit($event)"></app-ac-persons>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.exercises') }}" leftIcon="pi pi-briefcase" [disabled]="isDisabled('exercises') || ac === null">
          <app-ac-exercises *ngIf="editMode()" [(ac)]="ac" (setEdit)="setEdit($event)"></app-ac-exercises>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.onlinetests') }}" leftIcon="pi pi-inbox" [disabled]="isDisabled('onlinetests') || ac === null">
          <app-ac-onlinetests *ngIf="editMode()" [ac]="ac" [partners]="partners" (setEdit)="setEdit($event)"></app-ac-onlinetests>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.time_schedule') }}" leftIcon="pi pi-clock" [disabled]="isDisabled('timing') || ac === null">
          <app-ac-timing *ngIf="editMode()" [ac]="ac" (setEdit)="setEdit($event)"></app-ac-timing>
        </p-tabPanel>

        <p-tabPanel header="{{ t('common.labels.files') }}" leftIcon="pi pi-copy" [disabled]="isDisabled('files') || !auth.canSeeFiles() || ac === null">
          <app-ac-files *ngIf="editMode() && auth.canSeeFiles()" [ac]="ac" (setEdit)="setEdit($event)"></app-ac-files>
        </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
